export type StepFormProps = {
  onNext?: (data?: any) => void;
  onBack?: (data?: any) => void;
  defaultValues?: any;
  hasBack?: boolean;
  actions?: JSX.Element;
  experianResult?: any;
  openCompany?: boolean;
};


export type DocumentProps = {
  type: string;
  uploaded: boolean;
  required: boolean;
}

export class FileProps {
  type: string;
  document: any;

  constructor(type: string, document: any) {
    this.type = type;
    this.document = document;
  }

}

export type User = {
  "id": string,
  "email": string,
  "verified": boolean,
  "customer": {
      "id": string,
      "firstname": string,
      "surname": string,
      "company": {
          "id": string,
          "name": string,
          "registrationNumber":number,
          "currency": string,
          "country": string,
          "status": string,
          "offer": string,
          "codatLink": string
      }
  }
}